import { useWindowDimensions } from 'react-native';

export const usePortfolioStyle = () => {
  const { width } = useWindowDimensions();
  const layoutStyle = width > 1152 ? 'row' : 'col';

  return {
    layoutStyle: {
      isRow: layoutStyle === 'row',
      isColumn: layoutStyle === 'col'
    }
  };
};
